import { PlusCircle } from "lucide-react";

import { PlainMessage } from "@bufbuild/protobuf";
import React from "react";
import { moneyToCurrency } from "~/lib/utils";
import { Button } from "~/components/ui/button";
import { Price } from "@egocentric-systems/ts-apis/booking_gateway/v1/events_pb";
import { UnlockBadge } from "~/app/tickets/[eventId]/_components/UnlockBadge";

interface Props {
  prices?: Array<PlainMessage<Price>>;
  onSelect: (price: PlainMessage<Price>) => void;
}

export function SelectPrice({ prices, onSelect }: Props) {
  return (
    <div className="flex flex-col gap-4">
      {prices?.map((price, i, { length }) => (
        <React.Fragment key={price.id}>
          <div className="flex flex-col">
            <div className="flex items-center justify-between gap-2">
              <div className="flex flex-col">
                <div className="flex flex-row gap-2">
                  {price.isUnlocked && <UnlockBadge type="price" />}
                  <span>{price.name}</span>
                </div>
                <span className="font-bold">
                  {moneyToCurrency(price.value)}
                </span>
              </div>

              <Button variant="outline" onClick={() => onSelect(price)}>
                <PlusCircle />
              </Button>
            </div>
            <span className="text-sm text-muted-foreground">
              {price.description}
            </span>
          </div>

          {i !== length - 1 && <hr />}
        </React.Fragment>
      ))}
    </div>
  );
}
